import React, { useEffect, useRef } from "react"

/**
 * Caixa "Não sou um robô" (reCAPTCHA v2), exigida pelo backend após 3 senhas erradas.
 *
 * Carrega o script do Google só quando o componente aparece (sem dependência npm).
 *
 * Props:
 *  - siteKey: chave pública devolvida pelo LoginFornecedor (captchaSiteKey)
 *  - onChange: (token) => void — "" quando expira ou é reiniciado
 *  - resetKey: mude o valor para reiniciar a caixa (o token é de uso único)
 */

let carregando = null

function carregarScript() {
    if (window.grecaptcha && window.grecaptcha.render) return Promise.resolve(window.grecaptcha)
    if (carregando) return carregando

    carregando = new Promise((resolve, reject) => {
        window.__recaptchaV2Carregado = () => resolve(window.grecaptcha)
        const script = document.createElement("script")
        script.src =
            "https://www.google.com/recaptcha/api.js?onload=__recaptchaV2Carregado&render=explicit&hl=pt-BR"
        script.async = true
        script.defer = true
        script.onerror = () => {
            carregando = null
            reject(new Error("Falha ao carregar o reCAPTCHA"))
        }
        document.head.appendChild(script)
    })
    return carregando
}

export default function RecaptchaV2({ siteKey, onChange, resetKey }) {
    const container = useRef(null)
    const widgetId = useRef(null)
    const onChangeRef = useRef(onChange)
    onChangeRef.current = onChange

    useEffect(() => {
        let ativo = true
        carregarScript()
            .then(grecaptcha => {
                if (!ativo || !container.current || widgetId.current !== null) return
                widgetId.current = grecaptcha.render(container.current, {
                    sitekey: siteKey,
                    callback: token => onChangeRef.current(token),
                    "expired-callback": () => onChangeRef.current(""),
                    "error-callback": () => onChangeRef.current(""),
                })
            })
            .catch(() => onChangeRef.current(""))
        return () => {
            ativo = false
        }
    }, [siteKey])

    useEffect(() => {
        if (widgetId.current !== null && window.grecaptcha) {
            window.grecaptcha.reset(widgetId.current)
            onChangeRef.current("")
        }
    }, [resetKey])

    return <div ref={container} style={{ display: "inline-block", margin: "8px 0" }} />
}
